import { IUserProfileModel } from '@Shared/models';

export const REQUEST_USER_PROFILES = 'REQUEST_USER_PROFILES';
export const RECEIVE_USER_PROFILES = 'RECEIVE_USER_PROFILES';

export class RequestUserProfiles {
  readonly type = REQUEST_USER_PROFILES;
}

export class ReceiveUserProfiles {
  readonly type = RECEIVE_USER_PROFILES;
  constructor(
    public invitedProfiles: IUserProfileModel[],
    public activeProfiles: IUserProfileModel[],
    public inactiveProfiles: IUserProfileModel[]
  ) {}
}

export type UserProfileAction = RequestUserProfiles | ReceiveUserProfiles;
